<template>
  <div class="search-container">
    <input
      type="text"
      :placeholder="$t('search.placeholder')"
      @click="filterOpen = !filterOpen"
    />
    <img
      src="@/assets/icons/filter.svg"
      @click="filterOpen = !filterOpen"
      alt="filter"
      class="filter-icon"
    />
    <div class="filter" v-if="filterOpen" @scroll="scroll($event)">
      <div
        class="form"
        v-if="!orders.length"
        :style="loading ? 'opacity: 0 !important; pointer-events: none' : ''"
      >
        <h2 class="title">{{ $t("search.advancedSearch") }}</h2>
        <h3 v-if="noOrders" class="no-orders">
          {{ $t("search.noOrders") }}
        </h3>
        <div class="search">
          <p class="subtitle">{{ $t("search.filters") }}</p>
          <div class="filters-container">
            <div class="filter-item" v-for="(filter, index) in filters">
              <select
                v-model="filter.key"
                :disabled="filters.length == restFilters.length"
              >
                <option
                  v-for="filterKey in restFilters"
                  :hidden="filterKey.hidden"
                  :value="filterKey.key"
                >
                  {{ $t(`search.fields.${filterKey.key}.title`) }}
                </option>
              </select>
              <input
                type="text"
                v-if="
                  !supportedFiltersKeys.filter((el) => el.key === filter.key)[0]
                    .value
                "
                v-model="filter.value"
                :placeholder="$t(`search.fields.${filter.key}.placeholder`)"
              />
              <select v-else v-model="filter.value">
                <option
                  v-for="(option, index) in supportedFiltersKeys
                    .filter((el) => el.key === filter.key)[0]
                    .value.split('|')"
                  :selected="
                    index ===
                    supportedFiltersKeys
                      .filter((el) => el.key === filter.key)[0]
                      .value.split('|').length -
                      1
                  "
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
              <button class="add-button" @click="addToFilter(index)">+</button>
              <button class="remove-button" @click="removeFromFilter(index)">
                -
              </button>
            </div>
          </div>
        </div>
        <div class="date">
          <p class="subtitle">{{ $t("search.date") }}</p>
          <div class="date-range">
            <div class="input">
              <label>{{ $t("search.from") }}</label>
              <input type="date" :placeholder="$t('search.from')" v-model="model.from_date" />
            </div>
            <div class="input">
              <label>{{ $t("search.to") }}</label>
              <input type="date" :placeholder="$t('search.to')" v-model="model.to_date" />
            </div>
          </div>
        </div>
        <div class="action">
          <button @click="search">{{ $t("search.apply") }}</button>
        </div>
      </div>
      <div
        class="loader"
        v-if="loading && !orders.length"
        :style="!loading ? 'opacity: 0 !important; pointer-events: none' : ''"
      >
        {{ $t("search.loading") }}
      </div>
      <div v-if="orders.length && !noOrders">
        <div
          class="applied-filters"
          @click="clearFilters"
          :title="$t('search.clickToEditFilters')"
        >
          <span v-for="(filter, index) in filters">
            <span v-if="filter.value">
              {{ $t(`search.fields.${filter.key}.title`) }}
              {{ filter.value
              }}<span v-if="index !== filters.length - 1 && filters.length > 1"
                >,</span
              ><span v-else>.</span>
            </span>
          </span>
          <span v-if="filters.length == 0">{{ $t("search.clickToEditFilters") }}</span>
        </div>
        <div class="results">
          <order-card
            class="order"
            v-for="order in orders"
            :data="order"
          />
          <div class="loading-more-orders" v-if="loading">
            {{ $t("search.loadingMoreOrders") }}
          </div>
          <div class="loading-more-orders" v-else-if="page == lastPage">
            {{ $t("search.endOfResults") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderCard from "@/components/dispatching/OrderCard";
import axios from "axios";

export default {
  name: "SearchInput",
  components: {
    OrderCard,
  },
  data() {
    return {
      filterOpen: false,
      supportedFiltersKeys: [
        {
          key: "customer",
          title: "Customer",
          placeholder: "Enter customer name, phone number or email",
        },
        {
          key: "driver",
          title: "Driver",
          placeholder: "Enter driver name or taxi number",
        },
        {
          key: "pickup_sector",
          title: "Pickup sector",
          placeholder: "Enter pickup sector",
        },
        {
          key: "dropoff_sector",
          title: "Dropoff sector",
          placeholder: "Enter dropoff sector",
        },
        { key: "order_id", title: "Order ID", placeholder: "Enter order id" },
        {
          key: "requested_by",
          title: "Request by",
          placeholder: "Requested by",
          value: "APP|DASHBOARD",
        },
        {
          key: "car",
          title: "Car",
          placeholder: "Enter Plate Number",
        },
      ],
      filters: [
        {
          key: "customer",
          placeholder: "Enter customer name, phone number or email",
          value: "",
          title: "Customer",
        },
      ],
      model: {
        from_date: null,
        to_date: null,
      },
      page: 1,
      loading: false,
      noOrders: false,
      lastPage: 0,
      orders: [],
      nextPageLink: "",
    };
  },
  watch: {
    filterOpen: function (newVal) {
      if (newVal) {
        window.addEventListener("keydown", (evt) => {
          if (evt.which == 27) this.filterOpen = false;
        });
        window.addEventListener("click", (evt) => {
          if (
            !this.$el.contains(evt.target) &&
            !evt.target.hasAttribute(this.$options._scopeId)
          ) {
            this.filterOpen = false;
          }
        });
      } else {
        window.removeEventListener("keydown", () => {});
        window.removeEventListener("click", () => {});
      }
    },
  },
  computed: {
    restFilters: function () {
      let filters = [...this.supportedFiltersKeys];
      filters.forEach((el, index) => {
        el.hidden = false;
        this.filters.forEach((filterEl) => {
          if (filterEl.key === el.key) el.hidden = true;
        });
      });
      return filters;
    },
  },
  methods: {
    removeFromFilter(index) {
      if (index > -1 && this.filters.length > 1) this.filters.splice(index, 1);
    },
    addToFilter(index) {
      let key = "";
      let placeholder = "";
      let value = "";
      for (let i = 0; i < this.restFilters.length; i++) {
        if (!this.restFilters[i].hidden) {
          key = this.restFilters[i].key;
          placeholder = this.restFilters[i].placeholder;
          value = this.restFilters[i].value || "";
          break;
        }
      }
      if (this.filters.length < this.supportedFiltersKeys.length)
        this.filters.splice(index + 1, 0, {
          key: key,
          placeholder: placeholder,
          value: value,
        });
    },
    formateData() {
      let modelCopy = this.model;
      Object.values(this.filters).forEach((o, index) => {
        if (o.value) modelCopy[o.key] = o.value;
        else this.filters.splice(index, 1);
      });
      return modelCopy;
    },
    search() {
      this.loading = true;
      this.noOrders = false;
      this.$store
        .dispatch("advancedSearch", this.formateData())
        .then((response) => {
          if (response.data.length) {
            this.orders.push(...response.data);
            this.nextPageLink = response.next_page_url;
            this.lastPage = response.last_page;
          } else {
            this.noOrders = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadNextPage() {
      this.loading = true;
      axios
        .get(this.nextPageLink, {
          params: this.model,
        })
        .then((response) => {
          this.orders.push(...response.data.data.data);
          this.nextPageLink = response.data.data.next_page_url;
          this.page++;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    scroll(event) {
      if (
        Math.round(event.target.scrollTop + event.target.offsetHeight) >=
          Math.round(event.target.scrollHeight) - 1 &&
        !this.loading &&
        this.nextPageLink
      ) {
        this.loadNextPage();
      }
    },
    clearFilters() {
      this.orders = [];
      this.noOrders = false;
      this.loading = false;
      (this.model = {
        from_date: null,
        to_date: null,
      }),
        (this.lastPage = 0);
      this.page = 1;
      this.nextPageLink = "";
      if (this.filters.length == 0) {
        this.filters = [
          {
            key: "customer",
            placeholder: "Enter customer name, phone number or email",
            value: "",
            title: "Customer",
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

@keyframes open-filter-container {
  from {
    transform: translateY(8px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

.search-container {
  margin-left: 24px;
  position: relative;
  float: left;
  z-index: 999999;
  input {
    padding: 12px 16px;
    border-radius: 6px;
    background: #f7f8fa;
    width: 400px;
    max-width: 400px;
    border: 1px solid #c1c5d8;
    color: #222629;
    float: left;
    font-size: 14px;

    &::placeholder {
      color: #788e98;
    }

    &:focus {
      outline: none;
    }
  }

  .filter-icon {
    width: 20px;
    max-height: 20px;
    max-width: 20px;
    height: auto;
    position: absolute;
    right: 14px;
    cursor: pointer;
    padding: 2px;
    top: 50%;
    transform: translateY(-50%);
  }

  .filter {
    position: absolute;
    top: calc(100% + 6px);
    border-radius: 6px;
    padding: 24px 28px;
    background: #fff;
    color: #202731;
    max-width: 600px;
    max-height: calc(100vh - 64px - 20px);
    min-height: 64px;
    overflow-y: overlay;
    width: max-content;
    box-shadow: 0px 0px 8px rgba(#202731, 0.12);
    float: left;
    animation: open-filter-container 0.2s ease-out;
    z-index: 999999;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f7f8fa;
      overflow: hidden;
      border-radius: 0px 12px 12px 0px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #788e98;
      overflow: hidden;
      border-radius: 12px;
    }

    .form {
      width: 100%;
      float: left;
      .title {
        width: 100%;
        float: left;
      }
      .no-orders {
        width: 100%;
        float: left;
        font-size: 14px;
        font-weight: 400;
        margin-top: 4px;
        color: #e10015;
      }
      .search {
        float: left;
        width: 100%;
        margin-top: 10px;
        .subtitle {
          width: 100%;
          font-size: 12px;
          float: left;
          color: #788e98;
          margin: 0;
        }
        .filters-container {
          width: 100%;
          float: left;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 6px;
          .filter-item {
            width: 100%;
            float: left;
            display: flex;
            flex-direction: row;
            gap: 10px;

            select {
              padding: 12px 16px;
              border-radius: 8px;
              flex-shrink: 0;
              flex-grow: 1;
              float: left;
              cursor: pointer;
              appearance: menulist;
              box-shadow: 0px 0px 8px rgba(#202731, 0.12);
              font-size: 14px;
              min-height: 47px;

              &:focus {
                outline: none;
              }

              &:first-child {
                max-width: min-content;
              }
            }

            input {
              flex-shrink: 0;
              flex-grow: 1;
              width: auto;
            }

            .add-button {
              width: 48px;
              height: auto;
              flex-shrink: 0;
              flex-grow: 0;
              float: left;
              border-radius: 8px;
              background: #f7f8fa;
              border: 1px solid #e10015;
              color: #222629;
            }

            .remove-button {
              width: 48px;
              height: auto;
              flex-shrink: 0;
              flex-grow: 0;
              float: left;
              border-radius: 8px;
              background: #f7f8fa;
              border: 1px solid #222629;
              color: #222629;
            }
          }
        }
      }
      .date {
        float: left;
        width: 100%;
        margin-top: 14px;
        .subtitle {
          width: 100%;
          font-size: 12px;
          float: left;
          color: #788e98;
          margin: 0;
        }
        .date-range {
          width: 100%;
          float: left;
          display: flex;
          gap: 14px;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 0;

          .input {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            gap: 10px;

            label {
              font-size: 14px;
            }

            input {
              width: max-content;
              flex-grow: 1;
            }
          }
        }
      }
      .action {
        width: 100%;
        float: left;
        margin-top: 40px;

        button {
          background: #e10015;
          color: #fff;
          border-radius: 6px;
          padding: 10px 54px;
          float: right;
          transition: 0.2s;

          &:hover {
            background: #db0014;
          }
        }
      }
    }

    .loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .applied-filters {
      width: 100%;
      height: auto;
      float: left;
      font-size: 14px;
      color: #e10015;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
    }

    .results {
      width: 100%;
      height: 100%;
      float: left;
      margin-top: 14px;
      padding-bottom: 24px;

      .order:not(:first-child) {
        margin-top: 10px;
      }

      .loading-more-orders {
        width: 100%;
        margin-top: 18px;
        float: left;
        text-align: center;
        color: #788e98;
      }
    }
  }
}
</style>
